import React from 'react';
import PropTypes from 'prop-types';

import paths from '../../routes/paths';
import * as S from './styles';
import { Images } from '../../themes';

export default function Header({ activeRoute }) {
  return (
    <S.Main>
      <S.Content>
        <a href={`${paths.home}#overview`} style={{ textAlign: 'center' }}>
          <S.InStationLogo src={Images.branding.inStation} />
        </a>

        <S.Menu>
          <S.MenuItem active={activeRoute === 'overview'}>
            <a href={`${paths.home}#overview`}>overview</a>
          </S.MenuItem>
          <S.MenuItem active={activeRoute === 'features'}>
            <a href={`${paths.home}#features`}>features</a>
          </S.MenuItem>
          <S.MenuItem active={activeRoute === 'invillia'}>
            <a href={`${paths.home}#steps`}>steps</a>
          </S.MenuItem>
          <S.MenuItem active={activeRoute === 'pricing'}>
            <a href={`${paths.home}#pricing`}>pricing</a>
          </S.MenuItem>
          <S.MenuItem active={activeRoute === 'activate'}>
            <a href={paths.activate}>activate</a>
          </S.MenuItem>
        </S.Menu>
      </S.Content>
    </S.Main>
  );
}

Header.propTypes = {
  activeRoute: PropTypes.string,
};
